// 订单状态
export const OrderStatus = [
  { label: "已支付", value: "PAID", color: "success" },
  { label: "待支付", value: "PENDING", color: "warning" },
  { label: "已完成", value: "FINISHED", color: "processing" },
  { label: "已退款", value: "REFUNDED", color: "error" },
  { label: "已下单", value: "CREATED", color: "default" },
  { label: "已取消", value: "CANCELLED", color: "default" },
];

// 订单状态
export const DownloadOrderStatus = [
  { label: "已支付", value: 1, color: "success" },
  { label: "待支付", value: 2, color: "warning" },
  // { label: "已下单", value: 3, color: "processing" },
  { label: "已退款", value: 4, color: "error" },
];

// 支付方式
export const PaymentType = [
  { label: "移动端APP", value: "APP" },
];

// 支付方式
export const DownloadPaymentType = [
  { label: "支付宝app", value: 6 },
  { label: "微信app", value: 7 },
];

// 订单类型
export const OrderType = [
  { label: "纯虚拟权益", value: "VIRTUAL", color: "processing" },
  { label: "实物", value: "PHYSICAL", color: "success" },
  { label: "混合", value: "MIXED", color: "warning" },
];

// 订单类型
export const DownloadOrderType = [
  { label: "打印", value: 2, color: "success" },
  { label: "解锁", value: 10, color: "warning" },
];

// 产品类型
export const ProductType = [
  { label: "图书兑换券", value: "VOUCHER", color: "warning" },
  { label: "畅学会员", value: "VIP", color: "error" },
  { label: "实物", value: "PHYSICAL", color: "success" },
  { label: "金币", value: "GOLD", color: "processing" },
  { label: "线下服务", value: "OFFLINE_SERVICE", color: "processing" },
  { label: "线上课程", value: "ONLINE_COURSE", color: "warning" },
];

// 产品类型
export const DownloadProductType = [
  { label: "打印", value: 4, color: "processing" },
  { label: "书籍", value: 16, color: "warning" },
];

// 预购状态
export const BookPreConsumeStatus = [
  { label: "已完成", value: 1, color: "success" },
  { label: "未完成", value: 2, color: "error" },
];

// 产品状态
export const ProductStatus = [
  { label: "上架", value: "ON_SHELF", color: "success" },
  { label: "下架", value: "OFF_SHELF", color: "error" },
];

// 产品来源
export const ProductSource = [
  { label: "自营", value: "SELF" },
  { label: "第三方", value: "THIRD" },
];

// 自动发货
export const IsAutoDelivery = [
  { label: "是", value: 1, color: "success" },
  { label: "否", value: 0, color: "error" },
];

// 推荐
export const RecommendType = [
  { label: "最推荐", value: "MANAGER", color: "success" },
  { label: "无", value: "NONE", color: "default" },
  { label: "超值/性价比", value: "BEST_VALUE", color: "processing" },
  { label: "热销", value: "HOT", color: "error" },
];

// 预购状态
export const PreLockStatus = [
  { label: "待生效", value: "PENDING", color: "warning" },
  { label: "已发权益", value: "FULFILLED", color: "processing" },
  { label: "履约失败", value: "FAIL", color: "default" },
];

// 兑换码批次状态
export const RedeemCodeBatchStatus = [
  { label: "冻结", value: "FROZEN", color: "warning" },
  { label: "正常", value: "NORMAL", color: "processing" },
];

// 兑换码状态
export const RedeemCodeStatus = [
  { label: "待兑换", value: "WAIT_REDEEM", color: "warning" },
  { label: "已兑换", value: "REDEEMED", color: "processing" },
  { label: "已作废", value: "VOID", color: "error" },
];

// 打印类型
export const PrintType = [
  { label: "原书打印", value: 1, color: "processing" },
  { label: "自定义打印", value: 2, color: "warning" },
];

// 打印状态
export const PrintStatus = [
  { label: "已完成", value: 1, color: "success" },
  { label: "生成中", value: 2, color: "warning" },
  { label: "失败", value: 3, color: "error" },
];
